import { autoinject } from 'aurelia-framework';

@autoinject
export class MobileAppService {
  public isMobileApp = false;

  public init() {
    const result = (/.?[?].*isMobileApp=true/gi).exec(location.href);
    this.isMobileApp = result != null && result.length > 0;
  }
}
